import React, { Component } from "react";

class CommentsBox extends Component {
  state = {
    isEditing: false,
    comments: ''
  }

  componentDidMount = () => {
    const { comments } = this.props
    this.setState({comments})
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.comments !== this.props.comments) {
      const { comments } = this.props
      this.setState({comments})
    }
  }

  editComments = () => {
    this.setState({ isEditing: true });
  };

  updateComments = e => {
    const { value } = e.target;
    this.setState({ comments: value });
  };

  formatComments = comments =>
    comments && comments.split("\n").map((item, key) => (
      <span key={key}>
        {item}
        <br />
      </span>
    ));

  handleOnSave = () => {
    this.props.onSave(this.state.comments)
    this.setState({ isEditing: false })
  }

  render() {
    const { comments, isEditing } = this.state

    return (
      <div className="comments-box">
        <div className="comments-box-heading">
          <span>Comments</span>
          { !isEditing && 
            <button className="btn btn-default" onClick={this.editComments} >
                { comments ? 'Edit' : 'Add' }
            </button>
          }
        </div>

        { isEditing ? (
          <div>
             <textarea
              rows="5"
              onChange={this.updateComments}
              value={comments}
            />
            <div className="edit-comments-save-container">
              <button className="btn btn-default" onClick={this.handleOnSave}>
                Save
              </button>
            </div>
          </div>
         ) : this.formatComments(comments)
        }
      </div>
      )
    }
}

export default CommentsBox;
